import { Word } from '@attain-apps/string-builder'
import { TypeChecker } from '@attain-apps/type-guards'

export interface Tag {
  key: Tag.Key
  /**
   * @default true
   */
  value?: Tag.Value
}
export namespace Tag {
  export const isTag = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.object<Tag>({
      key: Key.isKey,
      value: TypeChecker.Factory.optional(Value.isValue),
    }),
  ).usingAlias('Tag')

  export type Key = Word
  export namespace Key {
    export const isKey: TypeChecker<Key> = Word.isWord.usingAlias('Tag.Key')
  }

  export type Value = Maybe.ReadonlyArray<Primitive>
  export namespace Value {
    export const isValue: TypeChecker<Value> = TypeChecker.Factory.union(
      TypeChecker.isPrimitive,
      TypeChecker.Factory.list(TypeChecker.isPrimitive),
    ).usingAlias('Tag.Value')
  }
}
